import { IHelpPanelLinkItem } from './HelpView.types';
export const helpConfigs = {
    managerReportingGuide:'./assets/TARReportingSimpleGuidePDF.pdf',
    payrollHomeUrl: 'https://microsoft.sharepoint.com/sites/hrw/Pages/Payrollhome.aspx',
    payStubUrl: 'https://hrprofile.microsoft.com/Paystub/Index',
    directDepositUrl: 'https://hrprofile.microsoft.com/DirectDeposit/Index',
    w2Url: 'https://microsoft.sharepoint.com/sites/hrw/Pages/myw2.aspx',
    w4Url: 'https://myapps.microsoft.com/signin/cicplus/63c25adf-a8f0-4f98-bd93-ddb4fc75fb8f',
    hrWeb: 'http://hrweb/US/Pages/default.aspx',
    payrollContactList: 'https://microsoft.sharepoint.com/sites/hrw/Pages/payrollreps.aspx',
    hrWebFAQ: 'https://microsoft.sharepoint.com/sites/hrw/Pages/payrollquestionshome.aspx',
    myHubUrl: 'https://microsoft.sharepoint.com/teams/MicrosoftMyHub/SitePages/Home.aspx',
    contactEmail: 'tarsup@microsoft.com',
    timecardDue: 'https://microsoft.sharepoint.com/sites/hrw/Pages/hourlyemployees.aspx',
    outlookReminders: 'https://microsoft.sharepoint.com/sites/hrw/Pages/outlookreminders.aspx',
    nonCAVacationPolicy: 'https://microsoft.sharepoint.com/sites/hrw/Pages/vacationus.aspx',
    nonCAVacationEstimator:
        'https://microsoft.sharepoint.com/sites/hrw/DocLibrary/HRweb/PayBenefits/vacationbalanceestimator.xlsx',
    timecardPolicy: 'https://microsoft.sharepoint.com/sites/hrw/Pages/timerecordinghourly.aspx',
    timecardFAQs: 'https://microsoft.sharepoint.com/sites/hrw/Pages/timecardfaq.aspx',
    overtimePolicy: 'https://microsoft.sharepoint.com/sites/hrw/Pages/overtime.aspx',
    shiftPayPolicy: 'https://microsoft.sharepoint.com/sites/hrw/Pages/shiftpayUS.aspx',
    tarToolGuide: 'https://aka.ms/TARguide',
    employeeCentral: 'https://aka.ms/ec',
    askHR: 'https://aka.ms/askhr',
    timeawayGuide:
        'https://microsoft.sharepoint.com/sites/hrw/Pages/TimeAwayUS.aspx?xsdata=MDN8MDF8fDM1MjIyMGQzMjA4NjQ3ZDY4ZGU3ODY1Y2U4NmIxNDkyfDcyZjk4OGJmODZmMTQxYWY5MWFiMmQ3Y2QwMTFkYjQ3fDF8MHw2Mzc2ODk4MTEwNjk0MDcxNzJ8R29vZHxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKV0lqb2lNQzR3TGpBd01EQWlMQ0pRSWpvaUlpd2lRVTRpT2lJaUxDSlhWQ0k2TVRKOQ%3D%3D&sdata=RCtvdGhnb2NPck1NeHBjbFlMQTdXQ3VkY2hpczFCSSt5aWJ2bys2WGh0dz0%3D&ovuser=72f988bf-86f1-41af-91ab-2d7cd011db47%2Cpyanez%40microsoft.com&OR=Teams-HL&CT=1633384516866',
    payrollFAQs:
        'https://microsoft.sharepoint.com/sites/hrw/Pages/payrollquestionshome.aspx?xsdata=MDN8MDF8fDcyYjBmYTEyZmUxYTQ2NDRiMzY2ZjcxYmExYTc0ZGRkfDcyZjk4OGJmODZmMTQxYWY5MWFiMmQ3Y2QwMTFkYjQ3fDF8MHw2Mzc2NDIyNzQ5ODY2MDMzMTV8R29vZHxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKV0lqb2lNQzR3TGpBd01EQWlMQ0pRSWpvaUlpd2lRVTRpT2lJaUxDSlhWQ0k2TVRKOQ%3D%3D&sdata=bzNnZkRXNCtCeVA0WGx3TnhpeXBUZmVRVkNNbHp3SXIvTUFzNHdNT0dLVT0%3D&ovuser=72f988bf-86f1-41af-91ab-2d7cd011db47%2Cceliabarca%40microsoft.com'
};

export const HelpLinks: IHelpPanelLinkItem[] = [
    {   hrefLink: helpConfigs.tarToolGuide, 
        target: 'TARTool', 
        id: 'TARToolLink', 
        text: 'TAR Tool User Guide' 
    },
    {
        hrefLink: helpConfigs.timecardPolicy,
        target: 'TimecardPolicy',
        id: 'TimecardPolicyLink',
        text: 'Timecard Policy for Hourly/Non-exempt'
    },
    {   hrefLink: helpConfigs.timecardFAQs, 
        target: 'TimecardFAQs', 
        id: 'timecardFAQsLink', 
        text: 'Timecard FAQ for Hourly/Non-exempt' },
    {
        hrefLink: helpConfigs.overtimePolicy,
        target: 'OvertimePolicy',
        id: 'overtimePolicyLink',
        text: 'Overtime Policy for Hourly/Non-exempt'
    },
    {
        hrefLink: helpConfigs.shiftPayPolicy,
        target: 'ShiftPayPolicy',
        id: 'shiftPayPolicyLink',
        text: 'Shift Pay Policy'
    },
    { hrefLink: helpConfigs.timeawayGuide, 
        target: 'TimeAwayGuide', 
        id: 'timeAwayGuideLink', 
        text: 'Time Away Guide to Policies' 
    },
        
    { hrefLink: helpConfigs.payrollFAQs, 
      target: 'PayrollFAQs', 
      id: 'payrollFAQsLink', 
      text: 'Payroll FAQs' 
    }
];

export const MainTitle = {
    helpTopics: 'Help Topics:',
    other: 'Other Help Topics:'
};
